import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserItem } from './user.model';
import {CollectionApiResponse} from '../../../lib/util/api-response';
import {DashboardItem} from './dashboard.model';
import {ProjektItem} from '../projektverwaltung/projekt.model';

type Dashboard = CollectionApiResponse<DashboardItem>;
type Projekte = CollectionApiResponse<ProjektItem>;

@Injectable()
export class DashboardService {
    /**
     * Constructor of address service
     *
     * @param http - The http client
     */
    constructor(private http: HttpClient) {}

    /**
     * Returns a list of addresses
     *
     * @returns - An observable that emits the response
     */
    public getDashboardItem(userId: number): Observable<Dashboard> {
      // tslint:disable-next-line:max-line-length
        return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/landingpage/getDashboard.php?${sessionStorage.getItem('session')}`) as Observable<
          Dashboard
        >;
    }

  public deleteDashboard(dashboardItem: DashboardItem): Observable<DashboardItem> {

    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/landingpage/deleteDashboard.php?dashboardId=${dashboardItem.id}&${sessionStorage.getItem('session')}`) as Observable<
      DashboardItem
      >;
  }

  public startTime(dashboardItem: DashboardItem): Observable<DashboardItem> {

    // tslint:disable-next-line:max-line-length
    return this.http.put(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/landingpage/startTime.php?${sessionStorage.getItem('session')}`, dashboardItem) as Observable<
      DashboardItem
      >;
  }

  public continueTime(dashboardItem: DashboardItem): Observable<DashboardItem> {

    // tslint:disable-next-line:max-line-length
    return this.http.put(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/landingpage/continueTime.php?${sessionStorage.getItem('session')}`, dashboardItem) as Observable<
      DashboardItem
      >;
  }

  public pauseTime(dashboardItem: DashboardItem): Observable<DashboardItem> {

    // tslint:disable-next-line:max-line-length
    return this.http.put(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/landingpage/pauseTime.php?${sessionStorage.getItem('session')}`, dashboardItem) as Observable<
      DashboardItem
      >;
  }

  public stopTime(dashboardItem: DashboardItem): Observable<DashboardItem> {

    // tslint:disable-next-line:max-line-length
    return this.http.put(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/landingpage/stopTime.php?${sessionStorage.getItem('session')}`, dashboardItem) as Observable<
      DashboardItem
      >;
  }

  public addDashboard(dashboardItem: DashboardItem): Observable<DashboardItem> {

    // tslint:disable-next-line:max-line-length
    return this.http.post(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/landingpage/addDashboard.php?${sessionStorage.getItem('session')}`, dashboardItem) as Observable<
      DashboardItem
      >;
  }

  public checkDashboard(): Observable<DashboardItem> {

    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/landingpage/checkDashboard.php?${sessionStorage.getItem('session')}`) as Observable<
      DashboardItem
      >;
  }


}
